<template>
  <nav style="width: 206px">
    <ul class="items-center text-base">
      <li class="mb-5">
        <router-link
          :to="{
            name: 'TxSummary',
            params: { id: transactionId },
          }"
          class="leading-8 pl-6 mb-6 box-border border-l-2 py-1 border-gray-12 font-semibold"
          :class="{
            'text-gray-92': $route.meta.isTxSummary,
            'border-secondary-main': $route.meta.isTxSummary,
          }"
        >
          依頼概要
        </router-link>
        <ul
          v-if="$route.name === 'TxSummary'"
          class="mt-6 ml-10 text-sm leading-4"
        >
          <li class="mb-4" v-if="conciergeComment">
            <div
              class="cursor-pointer text-gray-62"
              v-scroll-to="{ el: '#concierge-comment', offset: -110 }"
            >
              PRONIコンシェルジュ<br />
              からのひとことメモ
            </div>
          </li>
          <li class="mb-4">
            <div
              class="cursor-pointer text-gray-62"
              v-scroll-to="{ el: '#selection-content', offset: -300 }"
            >
              募集内容
            </div>
          </li>
          <li v-if="adminSupplements && adminSupplements.length > 0">
            <div
              class="cursor-pointer text-gray-62"
              v-scroll-to="{ el: '#admin-supplements' }"
            >
              PRONIメンバーズ<br />
              事務局コメント
            </div>
          </li>
        </ul>
      </li>
      <li v-if="transaction.isApplied" class="mb-5">
        <router-link
          :to="{
            name: 'TxApplication',
            params: { selectId: transactionId },
          }"
          class="leading-8 pl-6 mb-6 box-border border-l-2 py-1 border-gray-12 font-semibold"
          :class="{
            'text-gray-92': $route.meta.isTxApplication,
            'border-secondary-main': $route.meta.isTxApplication,
          }"
        >
          応募内容
        </router-link>
      </li>
      <li
        class="mb-5"
        v-if="transaction.responded_at || transaction.refused_at"
      >
        <router-link
          :to="{
            name: 'TxEstimate',
            params: { id: transactionId, patternNumber: 1 },
          }"
          class="leading-8 pl-6 mb-6 box-border border-l-2 py-1 border-gray-12 font-semibold"
          :class="{
            'text-gray-92': $route.meta.isTxEstimate,
            'border-secondary-main': $route.meta.isTxEstimate,
          }"
        >
          見積もり
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    transactionId: String,
    transaction: Object,
    conciergeComment: Object,
    adminSupplements: Array,
  },
};
</script>
